import {
  ActionReducerMapBuilder,
  PayloadAction,
  createSlice,
} from "@reduxjs/toolkit";
import { UserDto } from "interfaces/user";
import { fetchMeAction } from "store/actions/userAction";

export interface UserState {
  currentUser: UserDto | null;
}

const DEFAULT_STATE: UserState = {
  currentUser: null,
};

const userSlice = createSlice({
  name: "userSlice",
  initialState: DEFAULT_STATE,
  reducers: {
    setCurrentUser(state: UserState, action: PayloadAction<UserDto | null>) {
      state.currentUser = action.payload;
    },
  },
  extraReducers: (builder: ActionReducerMapBuilder<UserState>) => {
    builder.addCase(
      fetchMeAction.fulfilled,
      (state: UserState, action: PayloadAction<UserDto>) => {
        state.currentUser = action.payload;
      }
    );
  },
});

export const userReducer = userSlice.reducer;
export const userActions = userSlice.actions;
